import React from "react";
import { Route, Routes } from "react-router-dom";
import { ACLData } from "../data/ACLData";

function flattenMenuRoutes(menus = []) {
  return menus.reduce((routes, item) => {
    if (item?.route && item.route !== "#") {
      routes.push(item.route);
    }
    if (Array.isArray(item?.children)) {
      routes.push(...flattenMenuRoutes(item.children));
    }
    return routes;
  }, []);
}

function normalizeRoutePath(route) {
  if (route === "/") {
    return "/";
  }
  return String(route || "").replace(/^\/+/, "");
}

export default function MakeRouter({ menus }) {
  const activeRoutes = new Set(flattenMenuRoutes(menus));
  activeRoutes.add("/");
  activeRoutes.add("/logout");
  activeRoutes.add("/ubah-password");

  return (
    <Routes>
      {Object.keys(ACLData).map((code) => {
        const item = ACLData[code];
        if (!activeRoutes.has(item.to)) {
          return null;
        }
        return (
          <Route
            path={normalizeRoutePath(item.to)}
            element={item.comp}
            key={code}
          />
        );
      })}
    </Routes>
  );
}
